import GameIdButton from "components/Host/GameIdButton";
import { useGameContext } from "GameContext";

export default function GameInfoTab() {
  const {
    currentStage,
    gameId,

    hostIsPlaying,
    players,
    currentYear,
  } = useGameContext() as any;

  return (
    <div className="flex flex-col overflow-auto p-4 text-sm">
      <label>Current Year: {currentYear}</label>
      <label>Current Stage: {currentStage}</label>

      <div className="flex flex-row items-center gap-2">
        <label>GameId: </label>
        <div className="w-20"><GameIdButton gameId={gameId}/></div>
      </div>

      <label>Player Count: {players.length}</label>

      <div className="h-4"/>

      <div className= "flex flex-col gap-4 overflow-y-auto">
        <p>
          As the host/game-master you control the flow of the game, and ensure the game runs smoothly. Copy the keyword found under Game Settings and share it with the players to join your game. Connected players will show up under this game settings tab.
        </p>

        <p>
          Before starting the game you can configure the game settings, under the game settings tab. This includes selecting the negotiation timer length, the townhall voting time length, and the total amount of rounds to run the game. You also can adjust the roles of any joined players before starting the game. Once the game starts these values cannot be changed.
        </p>

        <p>
          Once the game starts you get new controls under the game settings tabs. You can now view the game being played in the newly available game tab. Access role settings and ability such as sending a particular role money through the role settings tab.
        </p>

        <p>
          As the host, you can transfer unlimited funds to players. Use this in particular with players that don't get a lot of capital, such as the Conservationists, and to encourage roleplay.
        </p>

        <p>
          The game will end when all rounds are played or if the host ends the game early. You can download the gamedata at any point in the game settings tab. 
        </p>
      </div>

    </div>
  )
}
